import { makeAutoObservable, runInAction } from 'mobx';

import {cmApi } from '@src/api';
import type { CmApi, PeriodDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

class PeriodsStore {
  periods: PeriodDto[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.periods.getPeriods();

    runInAction(() => {
      this.periods = data?.map((period) => ({ ...period, id: period.code })) ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const periodsStore = new PeriodsStore({ api: cmApi });
